module.exports.NOT_STARTED = 'Not Started';
module.exports.IN_PROGRESS = 'In Progress';
module.exports.COMPLETED = 'Completed';
